import * as go from 'gojs';

export enum LayoutAlgorithmType {
  D3_FORCE_LAYOUT = 'D3_FORCE_LAYOUT',
  GO_JS_HORIZONTAL_LAYERED_DIGRAPH_LAYOUT = 'GO_JS_HORIZONTAL_LAYERED_DIGRAPH_LAYOUT',
  GO_JS_VERTICAL_LAYERED_DIGRAPH_LAYOUT = 'GO_JS_VERTICAL_LAYERED_DIGRAPH_LAYOUT',
}

export type BaseLayoutSettings = {
  useUndoManager: boolean;
  linkKeyProperty: string;
};

export interface ForceLayoutSettings extends BaseLayoutSettings {
  enableLinkForce: boolean;
  enableChargeForce: boolean;
  enableCollisionForce: boolean;
  edgeMinLength: number;
  nodeInitialDistance: number;
  layoutCollideOffset: number;
  /** see {@link ForceCollide.iterations} */
  layoutCollideSimulationIterations: number;
  /** see {@link Simulation.alpha} */
  layoutSimulationAlpha: number;
  /** see {@link ForceManyBody.distanceMin} */
  layoutForceMinCharge: number;
  /** see {@link ForceManyBody.distanceMax} */
  layoutForceMaxCharge: number;
  /** see {@link ForceManyBody.strength} */
  layoutManyBodyStrengthMultiplier: number;
  edgeOffset: number;
  separateGraphOffset: number;
  edgePropertyEdgeOffset: number;
  labelTextPadding: number;
}

export interface LayeredLinkSettings {
  routing:
    | typeof go.Routing.Normal
    | typeof go.Routing.Orthogonal
    | typeof go.Routing.AvoidsNodes;
  curviness: number;
  fromEndSegmentLength: number;
  toEndSegmentLength: number;
}

export interface LayeredDigraphLayoutSettings extends BaseLayoutSettings {
  columnSpacing: number;
  direction: number;
  layerSpacing: number;
  isRouting: boolean;
  setsPortSpots: boolean;
  nonParallelLinksAreOrthogonal: boolean;
  maxParallelPortRadians: number;
  parallelPortRibbonSpacing: number;
  forwardLinkSettings: LayeredLinkSettings;
  backwardLinkSettings: LayeredLinkSettings;
  forceLayoutSettings: ForceLayoutSettings;
}

export type LayoutSettings = ForceLayoutSettings | LayeredDigraphLayoutSettings;
